(function () {
  'use strict'

  require('./modal')
  require('./scss/modal.scss')

  var MODULE_NAME = 'thismoment.modal'

  angular
    .module(MODULE_NAME, [
      'thismoment.modal.core'
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/modal/index.js